import React, { useState } from "react";
import { Box, Button, TextField, Paper, Typography } from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import useTranslation from "../../../shared/hooks/useTranslation";

interface ProgressUpdateFormProps {
  onSubmit: (message: string) => void;
  loading?: boolean;
}

const ProgressUpdateForm: React.FC<ProgressUpdateFormProps> = ({ onSubmit, loading }) => {
  const { translate } = useTranslation(["serviceOffers"]);
  const [message, setMessage] = useState("");

  const handleSubmit = () => {
    if (message.trim()) {
      onSubmit(message.trim());
      setMessage("");
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: "8px",
        border: "1px solid #E0E0E0",
        backgroundColor: "#FAFAFA",
      }}
    >
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, fontSize: "13px" }}>
        {translate("serviceOffers:execution.postUpdate")}
      </Typography>
      <TextField
        multiline
        minRows={2}
        maxRows={6}
        fullWidth
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={translate("serviceOffers:execution.updatePlaceholder")}
        sx={{
          mb: 1,
          "& .MuiOutlinedInput-root": {
            fontSize: "13px",
            backgroundColor: "#fff",
          },
        }}
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<SendIcon />}
          onClick={handleSubmit}
          disabled={!message.trim() || loading}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "13px",
          }}
        >
          {translate("serviceOffers:execution.postUpdateButton")}
        </Button>
      </Box>
    </Paper>
  );
};

export default ProgressUpdateForm;
